if (!customElements.get('quick-add-to-bag')) {
  customElements.define('quick-add-to-bag', class QuickAddToBag extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.init();
    }

    init(){
      this.componentActive = false;
      this.setElements();
      this.setEventListeners();
    }

    setElements(){
      this.elements = {};
      this.elements.addToBagButton = this.querySelector(`button.quick-add-to-bag__trigger`);
      this.elements.cartMessages = this.querySelector('.quick-add-to-bag__cart-messages');
      this.elements.optionSelectContainer = this.querySelector(`.quick-add-to-bag__option-select-container`);
      this.elements.parentCard = this.closest('product-card');
    }

    setEventListeners(){
      // establish events on the parent product card, to keep the code a little more separated from the product card code
      // use mouseenter to reduce event triggering over and over.
      this.elements.parentCard?.addEventListener('mouseenter', async (event) => {
        await this.open();
      });

      this.elements.parentCard?.addEventListener('mouseleave', (event) => {
        this.close();
      });
    }

    async open(){
      if(!this.elements.parentCard) return;
      const successfulInjection = await this.injectProductOptions();
      if(successfulInjection){
        this.classList.add('active');
        this.componentActive = true;
      }
    }

    close(){
      this.classList.remove('active');
      this.componentActive = false;
    }

    isActive(){
      return this.componentActive;
    }

    clearCartMessage(){
      if(!this.elements.cartMessages) return;
      this.elements.cartMessages.innerHTML = "";
    }

    setCartMessage(message){
      if(!message || message.trim().length == 0) return;
      if(!this.elements.cartMessages) return;
      this.elements.cartMessages.innerHTML = `<p class="quick-add-to-bag__cart-error">${message}</p>`;
    }

    async injectProductOptions(){
      const selectedSwatchData = this.elements.parentCard.getSelectedSwatchData();
      if(Object.keys(selectedSwatchData).length < 1) return false;
      try {
        await Promise.all([
          this.getProductOptionData(selectedSwatchData),
        ]);
        return true;
      } catch(error){
        console.error(error);
      }
      return false;
    }

    async getProductOptionData(selectedSwatchData) {
      if(!selectedSwatchData) return false;
      const variantData = await this.fetchProductOptionData(selectedSwatchData.fetch_url);
      if(variantData){
        const html = new DOMParser().parseFromString(variantData, 'text/html');
        this.updateProductOptions(html.querySelector('.template-container'));
        return Promise.resolve();
      }
      return false;
    }

    async fetchProductOptionData(productFetchUrl) {
      if(!productFetchUrl) return false;
      try{
        const response = await fetch(`${productFetchUrl}&view=product-card-add-to-bag-options`);
        const responseHTML = await response.text();
        return responseHTML;
      } catch (error) {
        console.error(error);
      }
      return false;
    }

    updateProductOptions(html){
      if(!html) return;
      this.elements.optionSelectContainer.innerHTML = html.innerHTML;
      this.updateProductOptionsAvailability();
    }

    updateProductOptionsAvailability() {
      this.clearCartMessage();
      const cardVariants = this.elements.parentCard.getVariants();
      const optionGroups = this.elements.parentCard.querySelectorAll('.product-card__option');

      // Store the current selection for each option level in key-value pair
      let currentSelection = {};
      optionGroups.forEach((group) => {
        const selectedRadio = group.querySelector('input:checked');
        if (selectedRadio) {
          currentSelection[group.dataset.optionKey] = selectedRadio.value;
        }
      });

      optionGroups.forEach((group) => {
        const radios = group.querySelectorAll('input[type="radio"]');
        const isColorOption = group.classList.contains('product-card-swatches');

        radios.forEach((radio) => {
          let isAvailable;
          let isImpossibleCombination = false;

          const tempSelection = { ...currentSelection, [group.dataset.optionKey]: radio.value };

          // Check if this combination is possible
          isImpossibleCombination = !cardVariants.some(variant =>
            Object.keys(tempSelection).every(key => variant[key] === tempSelection[key])
          );

          if (isColorOption) {
            // For color options, check if all combinations with this color are unavailable
            isAvailable = cardVariants.some(variant =>
              variant[group.dataset.optionKey] === radio.value && variant.available
            );
          } else {
            // For other options, check availability based on current selection with this option's value
            isAvailable = cardVariants.some(variant =>
              Object.keys(tempSelection).every(key =>
                variant[key] === tempSelection[key] && variant.available
              )
            );
          }

          // Update class based on availability and impossibility
          if(!isColorOption){
            radio.disabled = !isAvailable || isImpossibleCombination;
          }
          radio.classList.toggle('option-unavailable', !isAvailable);
          radio.classList.toggle('option-impossible', isImpossibleCombination);
        });
      });
    }
  });
}
